import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PublicSiteHeader } from '@/components/public/PublicSiteHeader';

const CoveragePage: React.FC = () => {
  const { t } = useTranslation('landing');

  const coveragePillars = [
    { title: t('coveragePillar1Title'), text: t('coveragePillar1Text') },
    { title: t('coveragePillar2Title'), text: t('coveragePillar2Text') },
    { title: t('coveragePillar3Title'), text: t('coveragePillar3Text') },
    { title: t('coveragePillar4Title'), text: t('coveragePillar4Text') },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <PublicSiteHeader />

      <main className="mx-auto max-w-6xl px-6 py-12">
        <section className="rounded-2xl border border-[#E2E8F0] bg-white p-10 shadow-sm">
          <div className="mb-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#E10613]">{t('coveragePageEyebrow')}</div>
          <h1 className="mt-3 text-4xl font-black leading-tight text-[#0F172A] md:text-5xl">
            {t('coveragePageHeadline')}
          </h1>
          <p className="mt-4 max-w-4xl text-base text-[#475569]">
            {t('coveragePageSub')}
          </p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs font-semibold uppercase tracking-widest">
            {['Rwanda', 'Uganda', 'Burundi'].map((country) => (
              <span
                key={country}
                className="rounded-full border border-[#FCA5A5] bg-[#FEF2F2] px-4 py-2 text-[#E10613]"
              >
                {country}
              </span>
            ))}
          </div>
        </section>

        <section className="mt-8 grid gap-4 md:grid-cols-2">
          {coveragePillars.map((pillar) => (
            <article key={pillar.title} className="rounded-xl border border-[#E2E8F0] bg-white p-5 shadow-sm">
              <h2 className="text-xs font-bold uppercase tracking-wider text-[#E10613]">{pillar.title}</h2>
              <p className="mt-2 text-sm text-[#475569]">{pillar.text}</p>
            </article>
          ))}
        </section>

        <section className="mt-8 rounded-xl border border-[#E2E8F0] bg-white p-6 shadow-sm">
          <h2 className="text-lg font-black text-[#0F172A]">{t('commercialAccess')}</h2>
          <p className="mt-3 text-sm text-[#475569]">
            {t('commercialAccessSub')}
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link
              to="/login"
              className="rounded-lg bg-[#E10613] px-5 py-3 text-xs font-bold uppercase tracking-widest text-white hover:bg-[#C1121F]"
            >
              {t('requestAccess')}
            </Link>
            <Link
              to="/"
              className="rounded-lg border border-[#E2E8F0] bg-white px-5 py-3 text-xs font-bold uppercase tracking-widest text-[#475569] hover:border-[#CBD5E1] hover:text-[#0F172A]"
            >
              {t('backToHome')}
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default CoveragePage;
